import { HttpClient, HttpGetArgs, HttpResponse } from './http';
import axios, { AxiosStatic } from 'axios';

export class AxiosHttpClient implements HttpClient {
    axios: AxiosStatic = axios;

    async get<T>(args: HttpGetArgs): Promise<HttpResponse<T>> {
        const { url, headers = {}, query = {} } = args;
        const { status, data } = await this.axios.get(url, {
            headers,
            params: query,
        });

        return {
            statusCode: status,
            body: data,
        };
    }
}
